export const PLAN_GROUP_IDS = {
  V17_PLANGROUP_ID: 97,
  V18_PLANGROUP_ID: 98,
  START_PLANGROUP_ID: 99,
  PRO_PLANGROUP_ID: 100,
  OFFER999_PLANGROUP_ID: 102,
  NEW_FEATURE_PACKAGE_MIX: 103,
  V20_PLANGROUP_ID: 104,
  V21_PLANGROUP_ID: 105,
  V21GBB_PLANGROUP_ID: 109,
  MOBILE_FREE_PLANGROUP_ID: 159,
  LARGELISTV23_PLANGROUP_ID: 183,
  AUSTRALIA_V1: 338,
  NEW_ZEALAND_V1: 339,
  GREAT_BRITAIN_V1: 340,
  GREAT_BRITAIN_LEAD_MAGNET: 341,
  BLACKBAUD_PARTNER_GROUP_ID: 353, // Standard & Premium plans only
  MWEB_CHARM_PRICING: 368,
  MICRO_EMAIL_PLANGROUP_ID: 379,
  // Plan-restructure experiment cohorts (CPD-25373). FOS assigns new trialers into one of
  // these two experimental plan groups; both render the repackaged pricing copy.
  PLAN_RESTRUCTURE_3PL: 385,
  PLAN_RESTRUCTURE_MWEB_CHARM: 386,
};

export const PLAN_RESTRUCTURE_EXPERIMENT_GROUP_IDS = [
  PLAN_GROUP_IDS.PLAN_RESTRUCTURE_3PL,
  PLAN_GROUP_IDS.PLAN_RESTRUCTURE_MWEB_CHARM,
];

export const INTERNATIONAL_PLAN_GROUP_IDS = [
  PLAN_GROUP_IDS.AUSTRALIA_V1,
  PLAN_GROUP_IDS.GREAT_BRITAIN_V1,
  PLAN_GROUP_IDS.NEW_ZEALAND_V1,
  PLAN_GROUP_IDS.GREAT_BRITAIN_LEAD_MAGNET,
];
